import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import createAxiosInstance from '../api';
import AuthLayout from '../pages/layout/AuthLayout';
import { menuItems } from '../pages/auth/sidebar';
import { dealerMenuItems } from '../pages/auth/sidebar';
import { useHook as DealerHook } from '../pages/auth/profileManagement/useHook';
import { useSelector } from 'react-redux';
interface ProtectRouteProps {
  // eslint-disable-next-line
  component: React.ComponentType<any>;
  Header_text: string;
  pagename?: string;
  intialroute?: string;
  userDetails?: UserDetails;
  id: string;
}

export interface MenuItem {
  label: string;
  icon: React.ReactElement;
  subMenu?: SubMenuItem[];
  submenuitems: string[];
  to?: string;
  route: string;
  id?: string;
  activeMenuIcon: React.ReactElement;
}

interface SubMenuItem {
  label: string;
  menu: string;
  permissionname: string;
  icon: (isActive: boolean) => React.ReactElement;
  to: string;
  id?: string;
}

interface UserDetails {
  firstName: string;
  lastName: string;
  email: string;
  avatar: string;
  roles: string[];
}

interface PagePermission {
  permissions: string[];
}

const intialuserdetails = {
  firstName: '',
  lastName: '',
  email: '',
  avatar: '',
  roles: [],
};

const permission_id = [
  'roles::assignPermission',
  'roles::get',
  'users::create',
  'users::updatePassword',
  'users::changeUserStatus',
  'roles::update',
  'roles::list',
  'roles::delete',
  'users::list',
  'users::update',
  'roles::create',
  'users::get',
  'globalAudit::list',
  'controllers::create',
  'controllers::list',
  'controllers::update',
  'controllers::get',
  'controllers::delete',
  'categories::create',
  'categories::list',
  'categories::subCategoryCreate',
  'categories::delete',
  'categories::subCategoryDelete',
  'equipments::create',
  'equipments::list',
  'equipments::get',
  'equipments::update',
  'equipments::delete',
  'units::create',
  'units::list',
  'units::get',
  'units::update',
  'units::delete',
  'inventories::manufacturedInventories',
  'inventories::unregisteredInventories',
  'inventories::registeredInventories',
  'inventories::assignInventories',
  'inventories::readyToDispatch',
  'customers::list',
  'customers::get',
  'customers::unitDetails',
  'customers::updateSubscription',
  'dashboard::manufacturedCount',
  'dashboard::unregisteredCount',
  'dashboard::registeredCount',
  'dashboard::numberOfUsers',
  'dashboars::numberOfCustomers',
  'dashboard::numberOfDealers',
  'dashboard::numberOfActiveSubscription',
  'dealers::create',
  'dealers::list',
  'dealers::get',
  'dealers::update',
  'dealers::updatePassword',
  'dealers::changeUserStatus',
];

const ProtectRoute: React.FC<ProtectRouteProps> = ({
  component: Component,
  ...props
}) => {
  const token = localStorage.getItem('ICEMAKE');
  const userRole = localStorage.getItem('role');
  const axiosInstance = createAxiosInstance();

  const navigate = useNavigate();
  const [pagePermissionIDs, setPagePermissionIDs] = useState<unknown[]>([]);
  const [pagePermission, setPagePermission] = useState<MenuItem[]>([]);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userDetails, setUserDetails] =
    useState<UserDetails>(intialuserdetails);
  const { fetchDealerInfo } = DealerHook();
  const { dealerInformation } = useSelector((state: any) => state.auth);

  useEffect(() => {
    setUserDetails(dealerInformation);
  }, [dealerInformation]);

  useEffect(() => {
    if (userRole !== 'dealer') {
      if (token) {
        validToken();
      } else {
        localStorage.clear();
        navigate('/login');
      }
    }
    if (userRole === 'dealer') {
      if (token) {
        setPagePermission(dealerMenuItems);
        setIsAuthenticated(true);
        setPagePermissionIDs(permission_id);
        getDealerDetails();
      } else {
        localStorage.clear();
        navigate('/dealerlogin');
      }
    }
  }, []);

  const validToken = async () => {
    await axiosInstance
      .get('/valid', { headers: { Authorization: `Bearer ${token}` } })
      .then(async () => {
        setIsAuthenticated(true);
        const user = await getuserdetails();
        await getRolePermission(user);
      })
      .catch(() => {
        localStorage.clear();
        navigate('/login');
      });
  };

  const getuserdetails = async () => {
    return await axiosInstance
      .get('/user')
      .then(async (response) => {
        setUserDetails(response.data.data);
        return response.data.data;
      })
      .catch(() => {
        setUserDetails(intialuserdetails);
        return null;
      });
  };

  const getDealerDetails = async () => {
    await fetchDealerInfo().then((res: any) => {
      if (res && res?.errorCode == 401) {
        localStorage.clear();
        navigate('/dealerlogin');
      }
    });
  };
  const filterpagepermission = (
    pagepermission: PagePermission[],
    user: UserDetails,
  ) => {
    const permissions: unknown[] = [
      ...new Set(pagepermission.flatMap((item) => item.permissions)),
    ].filter(Boolean);

    if (user?.roles.includes('*')) {
      setPagePermissionIDs(permission_id);
      setPagePermission(menuItems);
    } else {
      // if (!permissions.includes(props.id)) {
      //   navigate('/dashboard');
      // }

      if (permissions) {
        setPagePermissionIDs(permissions);
      }

      // const filteredMenuItems: (MenuItem | null)[] = menuItems
      //   .map((menuItem: MenuItem) => {
      //     if (menuItem.id === 'dashboard') {
      //       return menuItem;
      //     }

      //     const subMenu: SubMenuItem[] | undefined = menuItem?.subMenu?.filter(
      //       (subMenuItem: SubMenuItem) => {
      //         return permissions.includes(subMenuItem.id);
      //       },
      //     );

      //     if (subMenu && subMenu.length > 0) {
      //       return {
      //         ...menuItem,
      //         subMenu,
      //       };
      //     } else {
      //       return null;
      //     }
      //   })
      //   .filter(Boolean);
      setPagePermission(menuItems);
    }
  };

  const getRolePermission = async (user: UserDetails) => {
    await axiosInstance
      .get('/roleDetails')
      .then((response) => {
        if (response.data.data) {
          if (response.data.data) {
            filterpagepermission(response.data.data, user);
          }
        }
      })
      .catch(() => {
        setPagePermission([]);
      });
  };

  return isAuthenticated ? (
    <AuthLayout
      {...props}
      userDetails={userDetails}
      pagepermission={pagePermission}
    >
      <Component
        {...props}
        userDetails={userDetails}
        pagePermissionIDs={pagePermissionIDs}
        pagepermission={pagePermission}
      />
    </AuthLayout>
  ) : null;
};

export default ProtectRoute;
